import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet';
import aphroditeInterface from 'react-with-styles-interface-aphrodite/no-important';
import { css, withStyles } from 'react-with-styles';
import DefaultTheme from 'react-dates/lib/theme/DefaultTheme';

import Theme from './Theme';

ThemedStyleSheet.registerInterface(aphroditeInterface);
ThemedStyleSheet.registerTheme({
  ...Theme,
  reactDates: {
    ...DefaultTheme.reactDates,
    color: {
      ...DefaultTheme.reactDates.color,
      core: {
        ...DefaultTheme.reactDates.color.core,
        text: 'hsl(0, 0%, 21%)'
      }
    },
    spacing: {
      ...DefaultTheme.reactDates.spacing,
      displayTextPaddingTop: 5,
      displayTextPaddingBottom: 3,
      displayTextPaddingLeft: 9,
      displayTextPaddingRight: 9
    },
    font: {
      ...DefaultTheme.reactDates.font,
      input: {
        ...DefaultTheme.reactDates.font.input,
        size: '1em',
        lineHeight: '1em'
      }
    }
  }
});

export { css, withStyles, ThemedStyleSheet };



// WEBPACK FOOTER //
// ./src/assets/styles/withStyles.js